import React, { useMemo, useEffect, useState } from "react";
import { Row, Col, CardBody, Card, Alert, Container, Form, Input, FormFeedback, Label ,FormGroup, Button, CardTitle, Modal, ModalHeader, ModalBody, Table} from "reactstrap";
import Breadcrumb from '../Common/Breadcrumb';
import TableContainer from '../Common/TableContainer';
import Select from 'react-select'
import axios from '../../axios';
import moment from 'moment';
import SweetAlert from "react-bootstrap-sweetalert"
import { Link } from "react-router-dom"
import Numeral from 'react-numeral';
import FileSaver from 'file-saver'
import Xl from 'excel4node'


function OrderReconcillation() {

    const [companyhelp,setcompanyhelp]=useState([])
    const [Companyvalue, setCompanyvalue] = useState({})
    const [buyerhelp,setbuyerhelp]=useState([])
    const [buyervalue,setbuyervalue]=useState({label:"All",value:"0"})
    const [stylehelp,setstylehelp]=useState([])
    const [stylevalue,setstylevalue]=useState({label:"All",value:'All'})
    const [iponohelp,setiponohelp]=useState([])
    const [iponovalue,setiponovalue]=useState({label:"All",value:0})
    const [ordernohelp,setordernohelp]=useState([])
    const [ordernovalue,setordernovalue]=useState({label:"All",value:"All"})
    const [fromdate, setfromdate] = useState(new Date())
    const [todate, settodate] = useState(new Date())
    const [showtabel, setshowtabel] = useState(false)
    const [companyid, setcompanyid] = useState(JSON.parse(localStorage.getItem('company')))
    const [gridfilterhelp,setgridfilterhelp]=useState([])
    const [gridfilterhelpY,setgridfilterhelpY]=useState([])
    const [gridfilterhelpN,setgridfilterhelpN]=useState([])

    const [topheading, settopheading] = useState([])
    const [tableData, settableData] = useState([])
    const [tableheader, settableheader] = useState([])

    //nodatafound

    const [TimeAndActionNotFound, setTimeAndActionNotFound] = useState(false)
    const [TimeAndActionNotFound1, setTimeAndActionNotFound1] = useState(false)


    useEffect(() => {
        company()
        buyer()
        GetOrderReconciliationMstY()

        var date =  new Date()
      
        var firstday =  new Date(date.getFullYear(), date.getMonth(),1)
       
        var lastday = new Date(date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate());
        setfromdate(moment(firstday).format('YYYY-MM-DD'))
        settodate(moment(lastday).format('YYYY-MM-DD'))
        setCompanyvalue(JSON.parse(localStorage.getItem('company')))
    }, [])

    const statustype=[
        {label:"Completed",value:"Y"},
        {label:"Pending",value:"N"},
        {label:"All",value:"All"}
    ]


    const company=async()=>{
        await axios.instance.get("CompanyHelp/GetCompany")
        .then((res)=>{
            const data=res.data
            const option=data.map(row=>({
                "label":row.company,
                "value":row.companyId
            }))
            console.log(option,"companyhelp");
            setcompanyhelp(option)  
        }) 
    }

    const buyer=async()=>{
        await axios.instance.get("/BuyerHelp/BookedBuyerHelp")
        .then((res)=>{
            const data =res.data
            console.log(data,"buyerhelp")
            const option=data.map(row=>({
                "label":row.buyer,
                "value":row.buyerId
            }))
            // console.log(option,"buyerhelp")
            option.push({label:"All",value:0})
            setbuyerhelp(option)
        })
    }

    const styleHelp=async(value)=>{
        await axios.instance.get(`/Orderreconcillation/GetOrderReconStyleHelp?companyid=${Companyvalue.value}&buyerid=${value}`)
        .then((res)=>{
            const data =res.data
            const option=data.map(row=>({
                "label":row.style,
                  "value":row.style
            }))
            console.log(option,"stylehelp")
            option.push({label:"All",value:"All"})
            setstylehelp(option)
        })
      }

    const iponoHelp=async(value)=>{
        await axios.instance.get(`/Orderreconcillation/GetOrderReconIPONoHelp?companyid=${Companyvalue.value}&buyerid=${value}`)
        .then((res)=>{
            const data =res.data
            // console.log(res.data)
            const option=data.map(row=>({
                "label":row.ipono,
                 "value":row.ipono
            }))
            console.log(option,"ss")
            option.push({label:"All",value:0})
            setiponohelp(option)
        })
    }

    const ordernoHelp=async(value)=>{
        await axios.instance.get(`/Orderreconcillation/GetOrderReconOrderNoHelp?companyid=${Companyvalue.value}&buyerid=${value}`)
        .then((res)=>{
            const data =res.data
            // console.log(res.data)
            const option=data.map(row=>({
                "label":row.orderNo,
                 "value":row.orderNo
            }))
            console.log(option,"ss")
            option.push({label:"All",value:"All"})
            setordernohelp(option)
        })
    }

    const GetOrderReconciliationMstY=async()=>{
        await axios.instance.get(`/Orderreconcillation/Getallorderreconciliationmst`)
        .then((res)=>{
            console.log(res.data)
            const data =res.data
            const filteredDataY = data.filter(item => item.active === 'Y');
           /// const filteredDataN = data.filter(item => item.active === 'N');
            // console.log(filteredDataY,filteredDataN)
            const option=filteredDataY.map((row)=>({
                "label":row.columnName,
                 "value":row.columnName_Value,
                 "id":row.columnId
            }))
            setgridfilterhelpY(option)

            const option1=data.map((row)=>({
                "label":row.columnName,
                 "value":row.columnName_Value,
                 "id":row.columnId
            }))
            // option.push({label:"All",value:[0,"All"]})
            setgridfilterhelp(option1)
        })
    }



    const ViewData = async () =>{
        if(new Date(fromdate) >(new Date("1900-01-01"))  && new Date(todate) >(new Date("1900-01-01"))){
            await axios.instance.get(`/Orderreconcillation/GetAllOrderReconcillation1?companyId=${Companyvalue.value}&buyerId=${buyervalue.value}&IpoNo=${iponovalue.value}&OrderNo=${ordernovalue.value}&Style=${stylevalue.value}&fromDate=${fromdate}&toDate=${todate}`)
            .then((res)=>{
                if(res.data.length !== 0){
                    setshowtabel(true)
                    console.log(res.data, 'topheading')
                    // console.log(gridfilterhelpY)
                      const GridData = gridfilterhelpY.map(obj => obj.value);
                      const GridHeading = gridfilterhelpY.map(obj => obj.label);
                      const ids = gridfilterhelpY.map(obj => obj.id);
                      //console.log(GridData,GridHeading)
                        const selectedData = res.data.map(obj => {
                          const selectedObject = {};
                          GridData.forEach(key => {
                            if (obj.hasOwnProperty(key)) {
                              selectedObject[key] = obj[key];
                            }
                          });
                          return selectedObject;
                        });
                          console.log(GridHeading,selectedData,gridfilterhelpY)
                        settableData(selectedData)
                        settableheader(GridHeading)

                        console.log(gridfilterhelp,gridfilterhelpY)
                        let idjoin = ids.join()
                        console.log(ids,idjoin)
                         axios.instance.post(`/Orderreconcillation/Updateorderreconciliationmst?colId=${idjoin}`)

                } else {
                    setshowtabel(false)
                    setTimeAndActionNotFound(true)
                }
            })
        } else{
            setTimeAndActionNotFound1(true)
        }
    }

    const handleDownload = async() => {
        const value =   await axios.instance.get(`/Orderreconcillation/GetAllOrderReconcillationExcel?buyers=${buyervalue.label}&companys=${Companyvalue.label}&companyId=${Companyvalue.value}&buyerId=${buyervalue.value}&Style=${stylevalue.value[1]}&fromDate=${fromdate}&toDate=${todate}`, { responseType: 'blob' })
                .then(response => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));              
                })
               // window.open(value)
                .catch(error => {
                    console.error('Error downloading Excel file:', error);
                });
        };   

        const customStyles = {
            valueContainer: base => ({
              ...base,
              maxHeight: 100, // set a max height for the scrollable viewport
              overflowY: "scroll", // enable vertical scrolling
            }),
            multiValue: base => ({
              ...base,
              maxWidth: "70%", // set a max width to prevent overflow
              overflow: "hidden", // hide overflow
              textOverflow: "ellipsis", // add an ellipsis for truncated text
            }),
        }

    const ExporttoExcelConsolidate = async() => {
        handleDownload()
       const now = new Date();
      const year = now.getFullYear();
      const month = now.toLocaleString('default', { month: 'long' });
      const day = String(now.getDate()).padStart(2, '0');
      const hours = String(now.getHours()).padStart(2, '0');
      const minutes = String(now.getMinutes()).padStart(2, '0');
      const seconds = String(now.getSeconds()).padStart(2, '0');
      const amPm = hours >= 12 ? 'PM' : 'AM';
  const date =(`${month}_${day}_${year}_${hours}_${minutes}_${amPm}`)
  console.log(date)
    //   await window.open(`http://103.27.85.36/ExcelFilewebmins/Time&Action_${date}.xlsx`)
   await window.open(`http://192.168.1.8/TARGET_ERP_API/ExcelFile/OrderReconciliation_${date}.xlsx`)
          // })
       }

       
  return (
    <React.Fragment>
        <div className="account-pages my-5 pt-5 m-3 pt-sm-5">
            <Container fluid={true}>
                <Card style={{backgroundColor:"white"}}>
                    <CardBody className="p-4">
                        <Row>
                            <Col>
                                <Breadcrumb title="Report" breadcrumbItem="Order Reconcillation" />
                            </Col>
                        </Row>
                        <Row>
                            <Col sm='12' md='6' lg='3'>
                                <FormGroup> 
                                    <Label for='excompany'>
                                        Company
                                    </Label>         
                                    <Select 
                                        onChange={(value) => {
                                            // console.log(value.value)
                                            setCompanyvalue(value)
                                            // localStorage.setItem('company',JSON.stringify(value))
                                        }}
                                        value={Companyvalue}
                                        options={companyhelp}
                                        styles={{
                                            menuPortal: (provided, state) => ({
                                            ...provided,
                                            zIndex: 9999,
                                            }),
                                            menu: (provided, state) => ({
                                            ...provided,
                                            height: 'auto',
                                            }),
                                        }}
                                        menuPortalTarget={document.body}
                                        
                                    />
                                </FormGroup>
                            </Col>
                            <Col sm='12' md='6' lg='3'>
                                <FormGroup> 
                                    <Label for='exbuyer'>
                                        Buyer
                                    </Label>         
                                    {/* <Input id='exbuyer' name='Buyer' type='select'>
                                        <option>--Select--</option>
                                    </Input> */}
                                    <Select
                                        name="Buyer"
                                        value={buyervalue}
                                        onChange={(value)=>{
                                            // console.log(value.value,"buyervalue")
                                            setbuyervalue(value)
                                            styleHelp(value.value)
                                            iponoHelp(value.value)
                                            ordernoHelp(value.value)
                                            // bookedorder(value.value)
                                            console.log(value.value,"buyervalue")
                                        }}
                                        options={buyerhelp}
                                        styles={{
                                            menuPortal: (provided, state) => ({
                                            ...provided,
                                            zIndex: 9999,
                                            }),
                                            menu: (provided, state) => ({
                                            ...provided,
                                            height: 'auto',
                                            }),
                                        }}
                                        menuPortalTarget={document.body}
                                    />
                                </FormGroup>
                            </Col>
                            <Col sm='12' md='6' lg='3'>
                                <FormGroup> 
                                    <Label for='exstyleno'>
                                    IPO No
                                    </Label>         
                                    <Select
                                        name="Style No"
                                        value={iponovalue}
                                        onChange={(value)=>{
                                            setiponovalue(value) 
                                        }}
                                        options={iponohelp}
                                        styles={{
                                            menuPortal: (provided, state) => ({
                                            ...provided,
                                            zIndex: 9999,
                                            }),
                                            menu: (provided, state) => ({
                                            ...provided,
                                            height: 'auto',
                                            }),
                                        }}
                                        menuPortalTarget={document.body}
                                    />
                                </FormGroup>
                            </Col>
                            <Col sm='12' md='6' lg='3'>
                                <FormGroup> 
                                    <Label for='exstyleno'>
                                    Order No
                                    </Label>         
                                    {/* <Input id='exstyleno' name='Style No' type='select'>
                                        <option>--Select--</option>
                                    </Input> */}
                                    <Select
                                        name="Style No"
                                        value={ordernovalue}
                                        onChange={(value)=>{
                                            setordernovalue(value) 
                                        }}
                                        options={ordernohelp}
                                        styles={{
                                            menuPortal: (provided, state) => ({
                                            ...provided,
                                            zIndex: 9999,
                                            }),
                                            menu: (provided, state) => ({
                                            ...provided,
                                            height: 'auto',
                                            }),
                                        }}
                                        menuPortalTarget={document.body}
                                    />
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col sm='12' md='6' lg='4'>
                                <FormGroup> 
                                    <Label for='exstyleno'>
                                    Style
                                    </Label>         
                                    {/* <Input id='exstyleno' name='Style No' type='select'>
                                        <option>--Select--</option>
                                    </Input> */}
                                    <Select
                                        name="Style No"
                                        value={stylevalue}
                                        onChange={(value)=>{
                                            setstylevalue(value) 
                                        }}
                                        options={stylehelp}
                                        styles={{
                                            menuPortal: (provided, state) => ({
                                            ...provided,
                                            zIndex: 9999,
                                            }),
                                            menu: (provided, state) => ({
                                            ...provided,
                                            height: 'auto',
                                            }),
                                        }}
                                        menuPortalTarget={document.body}
                                    />
                                </FormGroup>
                            </Col>
                            <Col sm='12' md='6' lg='4'>
                                <FormGroup> 
                                    <Label for='exfromdate'>
                                 From Date
                                    </Label>         
                                    <Input id='exfromdate' name='Date' type='date' 
                                        value={fromdate}
                                        onChange={(e)=> setfromdate(e.target.value)}
                                        min="1900-01-01" maxLength='4' max="9999-12-31"
                                    />
                                </FormGroup>
                            </Col>
                            <Col sm='12' md='6' lg='4'>
                                <FormGroup> 
                                    <Label for='extodate'>
                                     To Date
                                    </Label>         
                                    <Input id='extodate'
                                        onChange={(e)=> settodate(e.target.value)}
                                        min="1900-01-01" maxLength='4' max="9999-12-31"
                                        value={todate}
                                        name='ToDate' type='date' />
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col sm='12' md='12' lg='12'>
                                <div className="mb-3">
                                <Label htmlFor="manufacturerbrand">
                                    <b> Grid Filter</b>
                                </Label>
                                <Select
                                    isMulti
                                    value={gridfilterhelpY}
                                    onChange={value => {
                                        setgridfilterhelpY(value)
                                        console.log(value)
                                    }}
                                    styles={customStyles}
                                    options={gridfilterhelp}
                                />
                                </div>
                            </Col>
                        </Row>
                        <Row>
                            <Col className="d-flex justify-content-end mt-auto mb-auto">
                                {/* <Button color='primary' size='md' className="mx-1 h-25" onClick={()=>{ViewData()}}>View</Button>
                                <Button size ="sm" style={{backgroundColor:'#00AC47',borderColor:'#00AC47'}}    className="btn btn-sm btn-primary h-25"  onClick={()=>{ExporttoExcelConsolidate()}}><i className="mdi mdi-microsoft-excel font-size-18 align-middle me-1 "></i>Excel</Button> */}
                                 <Button size='md' className="mx-1 w-lg" style={{backgroundColor:'#0E21A0',color:'white',fontWeight:'bolder'}} onClick={()=>{ViewData()}}>View</Button>
                          <Button size ="sm"  style={{backgroundColor:'#00AC47',borderColor:'#00AC47',fontWeight:'bolder'}}    className="btn btn-sm btn-primary w-lg"  onClick={()=>{ExporttoExcelConsolidate()}}><i className="mdi mdi-microsoft-excel font-size-18 align-middle me-1 "></i>Excel</Button>
                            </Col>
                        </Row>
                        {showtabel && (
                        <div className="mt-5 table-responsive">
                            <Table className=' table table-bordered border-0 table-sm' style={{cursor:'pointer'}}>
                                <thead>
                                    {/* <tr className="text-nowrap">
                                        <th>SNo</th>
                                        <th>Buyer</th>
                                        <th>IPO/Style</th>
                                        <th>Garment Description</th>
                                        <th>Order No</th>
                                        <th>Order Date</th>
                                        <th>Order Quantity</th>
                                        <th>Ship Date</th>
                                        <th>Garment Cons as Final BOM</th>
                                        <th>Fabric requirement as Final BOM</th>
                                        <th>Fabric Ordered (in mts)</th>
                                        <th>Short/Excess % Ordered</th>
                                        <th>Fabric Received in mts</th>
                                        <th>Short/Excess % Received</th>
                                        <th>Fabric Issued to Cutting (in mts)</th>
                                        <th>Garment Cut Qty (in Pcs)</th>
                                        <th>Garment Quantity Issued to Sewing</th>
                                        <th>Cutting Rejection %</th>
                                        <th>Garment Quantity Issued to Finishing</th>
                                        <th>Sewing Rejection %</th>
                                        <th>Shipped Quantity</th>
                                        <th>Finished and Packing Rejection</th>
                                        <th>Net Rejection %</th>
                                        <th>Buyer Ship Date</th>
                                        <th>Actual Ship Date</th>
                                        <th>No of Days Delayed</th>
                                        <th>Actual Order Quantity</th>
                                        <th>Actual Shipped Quantity</th>
                                        <th>Short/Excess %</th>
                                        <th>Shipped Quantity (in Pcs)</th>
                                        <th>Garment Cost</th>
                                        <th>Value Earned</th>
                                        <th>Duty Drawback</th>
                                        <th>Total Income</th>
                                        <th>Fabric Cost Actual</th>
                                        <th>Fabric Cost Costing</th>
                                        <th>Accessories Actual</th>
                                        <th>Accessories Costing</th>
                                        <th>CMT Charges Actual</th>
                                        <th>CMT Charges Costing</th>
                                        <th>Total Expense Actual</th>
                                        <th>Total Expense Costing</th>
                                        <th>Deviation From Planned Expense</th>
                                        <th>Profit/Loss</th>
                                    </tr> */}
                                    <tr style={{backgroundColor:'#11244C',color:'white'}}>
                                        <td>SNo</td>
                                        {tableheader.indexOf("Buyer") > -1 &&  <td>Buyer</td>}   
                                        {tableheader.indexOf("IPO") > -1 &&<td>IPO</td>}
                                        {tableheader.indexOf("Style") > -1 &&<td>Style</td>}
                                        {tableheader.indexOf("Garment Description") > -1 &&<td>Garment Description</td>}
                                        {tableheader.indexOf("OrderNo") > -1 &&<td>Order No</td>}
                                        {tableheader.indexOf("OrderDate") > -1 &&<td>Order Date</td>}
                                        {tableheader.indexOf("Order Quantity") > -1 &&<td>Order Quantity</td>}
                                        {tableheader.indexOf("Ship Date") > -1 &&<td>Ship Date</td>}
                                        {tableheader.indexOf("Garment Cons as Final BOM") > -1 &&<td>Garment Cons as Final BOM</td>}
                                        {tableheader.indexOf("Fabric requirement as Final BOM") > -1 &&<td>Fabric requirement as Final BOM</td>}
                                        {tableheader.indexOf("Fabric Ordered (in mts)") > -1 &&<td>Fabric Ordered (in mts)</td>}
                                        {tableheader.indexOf("Short/Excess % Ordered") > -1 &&<td>Short/Excess % Ordered</td>}
                                        {tableheader.indexOf("Fabric Received in mts") > -1 &&<td>Fabric Received in mts</td>}
                                        {tableheader.indexOf("Short/Excess % Received") > -1 &&<td>Short/Excess % Received</td>}
                                        {tableheader.indexOf("Fabric Issued to Cutting (in mts)") > -1 &&<td>Fabric Issued to Cutting (in mts)</td>}
                                        {tableheader.indexOf("Garment Cut Qty (in Pcs)") > -1 &&<td>Garment Cut Qty (in Pcs)</td>}
                                        {tableheader.indexOf("Garment Quantity Issued to Sewing") > -1 &&<td>Garment Quantity Issued to Sewing</td>}
                                        {tableheader.indexOf("Cutting Rejection %") > -1 &&<td>Cutting Rejection %</td>}
                                        {tableheader.indexOf("Garment Quantity Issued to Finishing") > -1 &&<td>Garment Quantity Issued to Finishing</td>}
                                        {tableheader.indexOf("Sewing Rejection %") > -1 &&<td>Sewing Rejection %</td>}
                                        {tableheader.indexOf("Shipped Quantity") > -1 &&<td>Shipped Quantity</td>}
                                        {tableheader.indexOf("Finished and Packing Rejection") > -1 &&<td>Finished and Packing Rejection</td>}
                                        {tableheader.indexOf("Net Rejection %") > -1 &&<td>Net Rejection %</td>}
                                        {tableheader.indexOf("Buyer Ship Date") > -1 &&<td>Buyer Ship Date</td>}
                                        {tableheader.indexOf("Actual Ship Date") > -1 &&<td>Actual Ship Date</td>}
                                        {tableheader.indexOf("No of Days Delayed") > -1 &&<td>No of Days Delayed</td>}
                                        {tableheader.indexOf("Actual Order Quantity") > -1 &&<td>Actual Order Quantity</td>}
                                        {tableheader.indexOf("Actual Shipped Quantity") > -1 &&<td>Actual Shipped Quantity</td>}
                                        {tableheader.indexOf("Short/Excess %") > -1 &&<td>Short/Excess %</td>}
                                        {tableheader.indexOf("Shipped Quantity (in Pcs)") > -1 &&<td>Shipped Quantity (in Pcs)</td>}
                                        {tableheader.indexOf("Garment Cost") > -1 &&<td>Garment Cost</td>}
                                        {tableheader.indexOf("Value Earned") > -1 &&<td>Value Earned</td>}
                                        {tableheader.indexOf("Duty Drawback") > -1 &&<td>Duty Drawback</td>}
                                        {tableheader.indexOf("Total Income") > -1 &&<td>Total Income</td>}
                                        {tableheader.indexOf("Fabric Cost Actual") > -1 &&<td>Fabric Cost Actual</td>}
                                        {tableheader.indexOf("Fabric Cost Costing") > -1 &&<td>Fabric Cost Costing</td>}
                                        {tableheader.indexOf("Accessories Actual") > -1 &&<td>Accessories Actual</td>}
                                        {tableheader.indexOf("Accessories Costing") > -1 &&<td>Accessories Costing</td>}
                                        {tableheader.indexOf("CMT Charges Actual") > -1 &&<td>CMT Charges Actual</td>}
                                        {tableheader.indexOf("CMT Charges Costing") > -1 &&<td>CMT Charges Costing</td>}
                                        {tableheader.indexOf("Total Expense Actual") > -1 &&<td>Total Expense Actual</td>}
                                        {tableheader.indexOf("Total Expense Costing") > -1 &&<td>Total Expense Costing</td>}
                                        {tableheader.indexOf("Deviation From Planned Expense") > -1 &&<td>Deviation From Planned Expense</td>}
                                        {tableheader.indexOf("Profit/Loss") > -1 &&<td>Profit/Loss</td>}
                                    </tr>
                                </thead>
                                <tbody>
                                    
                                {tableData.map((data,index)=>(
                                    <tr className="text-nowrap">
                                        <td>{index+1}</td> 
                                        {tableheader.indexOf("Buyer") > -1 &&<td>{data.Buyer}</td>}   
                                        {tableheader.indexOf("IPO") > -1 &&<td>{data.IPONO}</td>}
                                        {tableheader.indexOf("Style") > -1 &&<td>{data.style}</td>}
                                        {tableheader.indexOf("Garment Description") > -1 &&<td>{data.Garment}</td>}
                                        {tableheader.indexOf("OrderNo") > -1 &&<td>{data.OrderNo}</td>}
                                        {tableheader.indexOf("OrderDate") > -1 &&<td>{data.OrderDt}</td>}
                                        {tableheader.indexOf("Order Quantity") > -1 &&<td>{data.OrderQty}</td>}
                                        {tableheader.indexOf("Ship Date") > -1 &&<td>{data.Shipdt}</td>}
                                        {tableheader.indexOf("Garment Cons as Final BOM") > -1 &&<td>{data.Garment_Consumption}</td>}
                                        {tableheader.indexOf("Fabric requirement as Final BOM") > -1 &&<td>{data.Fabric_Requirement_Mts}</td>}
                                        {tableheader.indexOf("Fabric Ordered (in mts)") > -1 &&<td>{data.Fabric_Ordered_Mts}</td>}
                                        {tableheader.indexOf("Short/Excess % Ordered") > -1 &&<td>{data.Short_Excess_Per}</td>}
                                        {tableheader.indexOf("Fabric Received in mts") > -1 &&<td>{data.Fabrci_Received_Mts}</td>}
                                        {tableheader.indexOf("Short/Excess % Received") > -1 &&<td>{data.Short_Excess__Received_Per}</td>}
                                        {tableheader.indexOf("Fabric Issued to Cutting (in mts)") > -1 &&<td>{data.Fabric_Issue_To_Cutting}</td>}
                                        {tableheader.indexOf("Garment Cut Qty (in Pcs)") > -1 &&<td>{data.Garment_Qty_Issued_to_Sewing}</td>}
                                        {tableheader.indexOf("Garment Quantity Issued to Sewing") > -1 &&<td>{data.Garment_Quantity_Cuttable}</td>}
                                        {tableheader.indexOf("Cutting Rejection %") > -1 &&<td>{data.Cutting_Reject_Per}</td>}
                                        {tableheader.indexOf("Garment Quantity Issued to Finishing") > -1 &&<td>{data.Qty_Issued_Finish}</td>}
                                        {tableheader.indexOf("Sewing Rejection %") > -1 &&<td>{data.Sewing_Rejection_Per}</td>}
                                        {tableheader.indexOf("Shipped Quantity") > -1 &&<td>{data.Shiped_Qty}</td>}
                                        {tableheader.indexOf("Finished and Packing Rejection") > -1 &&<td>{data.Net_Rejection}</td>}
                                        {tableheader.indexOf("Net Rejection %") > -1 &&<td>{data.GNet_REJection_PER}</td>}
                                        {tableheader.indexOf("Buyer Ship Date") > -1 &&<td>{data.Buyer_Delivery_Date}</td>}
                                        {tableheader.indexOf("Actual Ship Date") > -1 &&<td>{data.Actual_Delivery_Date}</td>}
                                        {tableheader.indexOf("No of Days Delayed") > -1 &&<td>{data.Days_Delayed}</td>}
                                        {tableheader.indexOf("Actual Order Quantity") > -1 &&<td>{data.ActualQty}</td>}
                                        {tableheader.indexOf("Actual Shipped Quantity") > -1 &&<td>{data.Actual_Shiped_Qty}</td>}
                                        {tableheader.indexOf("Short/Excess %") > -1 &&<td>{data.SEPER}</td>}
                                        {tableheader.indexOf("Shipped Quantity (in Pcs)") > -1 &&<td>{data.Shiped_Qty_pcs}</td>}
                                        {tableheader.indexOf("Garment Cost") > -1 &&<td>{data.Garment_Cost}</td>}
                                        {tableheader.indexOf("Value Earned") > -1 &&<td>{data.Value_Earned}</td>}
                                        {tableheader.indexOf("Duty Drawback") > -1 &&<td>{data.Duty_Drawback}</td>}
                                        {tableheader.indexOf("Total Income") > -1 &&<td>{data.TotalIncome}</td>}
                                        {tableheader.indexOf("Fabric Cost Actual") > -1 &&<td>{data.FabActual}</td>}
                                        {tableheader.indexOf("Fabric Cost Costing") > -1 &&<td>{data.FabCosting}</td>}
                                        {tableheader.indexOf("Accessories Actual") > -1 &&<td>{data.Accessories_Actual}</td>}
                                        {tableheader.indexOf("Accessories Costing") > -1 &&<td>{data.Accessories_Costing}</td>}
                                        {tableheader.indexOf("CMT Charges Actual") > -1 &&<td>{data.CMTCharges_Actual}</td>}
                                        {tableheader.indexOf("CMT Charges Costing") > -1 &&<td>{data.CMTCharges_Costing}</td>}
                                        {tableheader.indexOf("Total Expense Actual") > -1 &&<td>{data.Total_Expenses_Actual}</td>}
                                        {tableheader.indexOf("Total Expense Costing") > -1 &&<td>{data.Total_Expenses_Costing}</td>}
                                        {tableheader.indexOf("Deviation From Planned Expense") > -1 &&<td>{data.Deviation_From_Planned_Expensess}</td>}
                                        {tableheader.indexOf("Profit/Loss") > -1 &&<td>{data.Profit_Loss}</td>}
                                    </tr> 
                                    ))}
                                </tbody>

                            </Table>
                        </div>
                        )}
                    </CardBody>
                </Card>
            </Container>

            {TimeAndActionNotFound ? (
                <SweetAlert
                    title="No Data Found"
                    timeout={2000}
                    style={{
                    position: "absolute",
                        justifyContent:'center',
                        alignItems:'center'
                    }}
                    showCloseButton={false}
                    showConfirm={false}
                    warning
                    onConfirm={() => {
                        setTimeAndActionNotFound(false);
                    }}
                ></SweetAlert>
                ) : null}

    {TimeAndActionNotFound1 ? (
                <SweetAlert
                    title="Invalid Date"
                    timeout={2000}
                    style={{
                    position: "absolute",
                        justifyContent:'center',
                        alignItems:'center'
                    }}
                    showCloseButton={false}
                    showConfirm={false}
                    warning
                    onConfirm={() => {
                        setTimeAndActionNotFound1(false);
                    }}
                ></SweetAlert>
                ) : null}

        </div>
    </React.Fragment>
  )
}

export default OrderReconcillation